import { render } from "./ListCustomerInvoicesActionButtonsRenderer.vue?vue&type=template&id=72e6cf12"
import script from "./ListCustomerInvoicesActionButtonsRenderer.vue?vue&type=script&lang=js"
export * from "./ListCustomerInvoicesActionButtonsRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__